import "./Process.css";
import { FaClipboardCheck, FaFileInvoiceDollar, FaUserShield, FaArrowRight } from "react-icons/fa";

export default function Process() {
  const steps = [
    {
      step: "01",
      icon: <FaClipboardCheck />,
      title: "Audit & Analyse du Site",
      desc: "Étude personnalisée de votre cahier des charges : évaluation des vulnérabilités, points d'accès et spécificités du lieu.",
    },
    {
      step: "02",
      icon: <FaFileInvoiceDollar />,
      title: "Devis Transparent sous 24h",
      desc: "Proposition technique et financière détaillée, chiffrage ferme sans frais cachés et engagement contractuel clair.",
    },
    {
      step: "03",
      icon: <FaUserShield />,
      title: "Déploiement Opérationnel",
      desc: "Mise en place immédiate d'agents formés, respect scrupuleux des consignes de poste et comptes-rendus réguliers.",
    },
  ];

  return (
    <section id="process" className="section process-section">
      <div className="process-header">
        <span className="section-tag">{"//"} MÉTHODE DE DÉPLOIEMENT</span>
        <h2 className="section-title">Notre Démarche en 3 Étapes</h2>
        <p className="section-subtitle">
          Un protocole rigoureux et transparent pour vous garantir une protection sans faille dès la prise de contact.
        </p>
      </div>

      <div className="process-grid">
        {steps.map((item, index) => (
          <div key={index} className="process-card">
            <div className="process-step-badge">{item.step}</div>
            <div className="process-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="process-cta-banner">
        <div className="cta-banner-text">
          <strong>Besoin d'un audit de sécurité ou d'un devis immédiat ?</strong>
          <p>Nos conseillers évaluent votre situation et vous répondent sous 24h ouvrées.</p>
        </div>
        <a href="#contact" className="btn-primary">
          Lancer ma demande de devis <FaArrowRight />
        </a>
      </div>
    </section>
  );
}
